var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinDecorator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 56,
    viewBox: "0 0 59 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3386_4124)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1763 12.0156C51.7896 18.6289 50.6215 30.5163 42.5688 38.569C34.516 46.6218 22.6287 47.7899 16.0154 41.1766L14.2869 39.448L43.4478 10.2871L45.1763 12.0156Z",
    fill: "url(#paint0_linear_3386_4124)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4478 10.2863C50.0611 16.8996 48.893 28.787 40.8402 36.8397C32.7875 44.8925 20.9001 46.0605 14.2869 39.4473C7.67359 32.8399 8.84168 20.9525 16.8944 12.8998C24.9472 4.84705 36.8345 3.67896 43.4478 10.2922V10.2863Z",
    fill: "url(#paint1_linear_3386_4124)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8727 33.1708C49.0701 25.4897 49.1114 15.9503 43.4479 10.2869C36.8347 3.67359 24.9473 4.84168 16.8946 12.8944C15.2604 14.5286 13.9094 16.322 12.8475 18.198C13.3785 18.4281 13.9153 18.6641 14.4463 18.8941C15.402 17.201 16.6232 15.5787 18.098 14.0979C25.3425 6.85339 36.0323 5.80329 41.979 11.7499C42.1029 11.8738 42.2267 12.0036 42.3506 12.1334C47.0761 17.2718 46.9168 25.6077 42.3506 32.3508C42.858 32.6221 43.3712 32.8935 43.8786 33.1649L43.8727 33.1708Z",
    fill: "url(#paint2_linear_3386_4124)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8197 11.2189C47.9197 17.0062 47.0643 27.8081 39.9083 35.3476C32.7522 42.8871 22.0094 44.303 15.9093 38.5156C9.81522 32.7283 10.6706 21.9264 17.8208 14.3869C24.9768 6.84741 35.7197 5.43155 41.8197 11.2189Z",
    fill: "#FFD662"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9789 11.7554C47.9255 17.7021 46.8754 28.3918 39.6309 35.6364C32.3864 42.8809 21.6966 43.931 15.75 37.9843C9.80924 32.0377 10.8593 21.3479 18.0979 14.1034C25.3425 6.85889 36.0322 5.80879 41.9789 11.7554Z",
    fill: "url(#paint3_linear_3386_4124)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1393 38.3501C10.6116 32.3386 11.7679 21.9497 18.8531 14.8585C25.9383 7.7733 36.3331 6.61111 42.3447 12.1389C42.2267 12.0091 42.1028 11.8793 41.973 11.7554C36.0264 5.80879 25.3366 6.85889 18.0921 14.1034C10.8593 21.3479 9.80924 32.0377 15.75 37.9843C15.8739 38.1082 16.0036 38.2321 16.1334 38.356L16.1393 38.3501Z",
    fill: "url(#paint4_linear_3386_4124)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4271 31.5249C43.6188 29.6312 44.5155 27.5487 45.0111 25.3541C45.7662 22.0209 45.5892 18.4576 44.079 15.3604C43.5539 14.2867 42.8873 13.2956 42.0791 12.4166C41.9552 12.3045 41.8313 12.1924 41.7015 12.0863C41.6956 12.0804 41.6838 12.0745 41.6779 12.0627C40.8992 11.4137 40.0497 10.8592 39.1353 10.4167C36.0322 8.90645 32.4689 8.72357 29.1416 9.4846C25.3424 10.3459 21.8794 12.393 19.1362 15.1363C18.0153 16.2572 17.0124 17.496 16.1628 18.8293C20.4576 20.7289 24.7347 22.6993 29 24.7524C33.5013 26.9174 37.979 29.1769 42.4448 31.5308L42.4271 31.5249Z",
    fill: "url(#paint5_linear_3386_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.563 38.5688C45.3653 35.7666 47.3357 32.4983 48.433 29.1533L46.7045 27.4248C45.6072 30.7698 43.6367 34.0381 40.8345 36.8403C39.5071 38.1677 38.0795 39.3063 36.5869 40.2502L38.3155 41.9787C39.808 41.0289 41.2357 39.8903 42.563 38.5688Z",
    fill: "url(#paint6_linear_3386_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0095 41.1824C19.4666 44.6395 24.3749 45.9728 29.413 45.3003L27.6845 43.5717C22.6877 44.2384 17.8324 42.9405 14.3754 39.5542L16.0036 41.1824H16.0095Z",
    fill: "url(#paint7_linear_3386_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4475 22.2807C49.3118 18.387 47.9078 14.753 45.1704 12.0156L43.4419 10.2871C46.1733 13.0186 47.5774 16.6585 47.719 20.5521L49.4475 22.2807Z",
    fill: "url(#paint8_linear_3386_4124)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.563 38.5686C44.7694 36.3622 46.4566 33.8667 47.6129 31.2769L45.8844 29.5483C44.7281 32.1441 43.0409 34.6337 40.8345 36.84L42.563 38.5686Z",
    fill: "url(#paint9_linear_3386_4124)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2297 39.9076C39.4716 40.1495 39.7312 40.3501 39.979 40.4858C40.0085 40.5035 40.0497 40.4858 40.0851 40.4504C40.1205 40.415 40.1382 40.3678 40.1205 40.3442C39.979 40.0964 39.7843 39.8368 39.5424 39.5949C39.3005 39.3531 39.0409 39.1525 38.7932 39.0168C38.7637 38.9991 38.7224 39.0168 38.687 39.0522C38.6516 39.0876 38.6339 39.1348 38.6516 39.1584C38.7932 39.4062 38.9878 39.6657 39.2297 39.9076ZM36.6871 41.6421C36.9289 41.8839 37.1826 42.0786 37.4304 42.2202C37.4599 42.2379 37.5012 42.2202 37.5366 42.1848C37.572 42.1494 37.5838 42.1081 37.572 42.0786C37.4304 41.8367 37.2357 41.5772 36.9938 41.3353C36.752 41.0934 36.4983 40.8987 36.2505 40.7571C36.221 40.7394 36.1797 40.7571 36.1443 40.7925C36.1089 40.8279 36.0971 40.8692 36.1089 40.8987C36.2505 41.1406 36.4452 41.4002 36.6871 41.6421ZM33.9379 43.0343C34.1798 43.2762 34.4335 43.4709 34.6695 43.6125C34.699 43.6302 34.7403 43.6125 34.7698 43.583C34.8051 43.5476 34.8169 43.5063 34.7992 43.4827C34.6577 43.2408 34.463 42.9871 34.2211 42.7511C33.9792 42.5093 33.7255 42.3146 33.4896 42.173C33.4601 42.1553 33.4188 42.173 33.3893 42.2025C33.3598 42.232 33.3421 42.2792 33.3598 42.3028C33.5014 42.5447 33.6961 42.7983 33.9379 43.0343ZM31.0295 44.0372C31.2714 44.2791 31.5192 44.4738 31.7551 44.6154C31.7787 44.6331 31.82 44.6154 31.8554 44.5859C31.8849 44.5564 31.8967 44.5151 31.8849 44.4856C31.7433 44.2496 31.5487 43.9959 31.3068 43.76C31.0649 43.5181 30.8171 43.3234 30.5811 43.1818C30.5575 43.1641 30.5163 43.1818 30.4809 43.2113C30.4514 43.2408 30.4396 43.2821 30.4514 43.3116C30.5929 43.5476 30.7876 43.8012 31.0295 44.0372ZM28.0031 44.6095C28.2391 44.8454 28.4868 45.046 28.7228 45.1876C28.7464 45.2053 28.7877 45.1935 28.8172 45.164C28.8467 45.1345 28.8585 45.0932 28.8408 45.0696C28.6992 44.8337 28.4986 44.5859 28.2627 44.3499C28.0267 44.1139 27.7789 43.9133 27.5429 43.7718C27.5193 43.7541 27.478 43.7659 27.4485 43.7954C27.419 43.8248 27.4072 43.8661 27.4249 43.8897C27.5665 44.1257 27.7671 44.3735 28.0031 44.6095ZM24.9236 44.6921C25.1596 44.928 25.4073 45.1227 25.6374 45.2702C25.661 45.2879 25.7023 45.2761 25.7318 45.2466C25.7613 45.2171 25.7672 45.1817 25.7554 45.1522C25.6079 44.9221 25.4132 44.6744 25.1773 44.4384C24.9413 44.2024 24.6935 44.0077 24.4634 43.8602C24.4398 43.8425 24.3985 43.8543 24.369 43.8838C24.3395 43.9133 24.3336 43.9487 24.3454 43.9782C24.4929 44.2083 24.6876 44.4561 24.9236 44.6921ZM21.8795 44.2319C22.1155 44.4679 22.3573 44.6626 22.5815 44.8101C22.6051 44.8277 22.6464 44.816 22.67 44.7924C22.6995 44.7629 22.7054 44.7275 22.6877 44.7039C22.5402 44.4797 22.3455 44.2319 22.1096 44.0018C21.8736 43.7659 21.6317 43.5712 21.4075 43.4237C21.3839 43.406 21.3426 43.4178 21.319 43.4414C21.2895 43.4709 21.2836 43.5063 21.3013 43.5299C21.4488 43.7541 21.6435 44.0018 21.8795 44.2319ZM43.9021 35.2294C44.144 35.4712 44.3445 35.7308 44.4802 35.9786C44.4979 36.0081 44.4802 36.0494 44.4448 36.0848C44.4094 36.1202 44.3622 36.1379 44.3386 36.1202C44.0909 35.9786 43.8313 35.7839 43.5894 35.542C43.3475 35.3002 43.147 35.0406 43.0113 34.7928C42.9936 34.7633 43.0113 34.722 43.0467 34.6866C43.0821 34.6512 43.1293 34.6335 43.1529 34.6512C43.4006 34.7928 43.6602 34.9875 43.9021 35.2294ZM45.6365 32.6867C45.8784 32.9286 46.0731 33.1823 46.2147 33.43C46.2324 33.4595 46.2147 33.5008 46.1793 33.5362C46.1439 33.5716 46.1026 33.5834 46.0731 33.5716C45.8312 33.43 45.5716 33.2354 45.3297 32.9935C45.0879 32.7516 44.8932 32.4979 44.7516 32.2501C44.7339 32.2206 44.7516 32.1794 44.787 32.144C44.8224 32.1086 44.8637 32.0968 44.8932 32.1086C45.1351 32.2501 45.3946 32.4448 45.6365 32.6867ZM47.0288 29.9376C47.2707 30.1794 47.4653 30.4331 47.6069 30.6691C47.6246 30.6927 47.6069 30.7399 47.5774 30.7694C47.542 30.8048 47.5007 30.8166 47.4771 30.7989C47.2353 30.6573 46.9816 30.4626 46.7456 30.2207C46.5037 29.9789 46.3091 29.7252 46.1675 29.4892C46.1498 29.4597 46.1675 29.4184 46.197 29.3889C46.2324 29.3535 46.2737 29.3417 46.2973 29.3594C46.5391 29.501 46.7928 29.6957 47.0288 29.9376ZM48.0317 27.0291C48.2736 27.271 48.4682 27.5188 48.6098 27.7548C48.6275 27.7784 48.6098 27.8197 48.5803 27.8551C48.5508 27.8846 48.5095 27.8964 48.48 27.8846C48.2441 27.743 47.9904 27.5483 47.7544 27.3064C47.5125 27.0645 47.3179 26.8168 47.1763 26.5808C47.1586 26.5572 47.1763 26.5159 47.2058 26.4805C47.2353 26.451 47.2766 26.4392 47.3061 26.451C47.542 26.5926 47.7957 26.7873 48.0317 27.0291ZM48.6039 24.0027C48.8399 24.2387 49.0405 24.4865 49.1821 24.7225C49.1998 24.7461 49.1821 24.7874 49.1585 24.8169C49.1349 24.8463 49.0877 24.8581 49.0641 24.8404C48.8281 24.6989 48.5803 24.4983 48.3444 24.2623C48.1084 24.0263 47.9078 23.7785 47.7662 23.5426C47.7485 23.519 47.7603 23.4777 47.7898 23.4482C47.8193 23.4187 47.8606 23.4069 47.8842 23.4246C48.1202 23.5662 48.368 23.7667 48.6039 24.0027ZM48.6865 20.9232C48.9225 21.1592 49.1172 21.407 49.2647 21.6371C49.2824 21.6607 49.2706 21.7019 49.2411 21.7314C49.2116 21.7609 49.1762 21.7668 49.1467 21.755C48.9166 21.6076 48.6688 21.4129 48.4329 21.1769C48.1969 20.9409 48.0022 20.6931 47.8547 20.4631C47.837 20.4395 47.8488 20.3982 47.8783 20.3687C47.9078 20.3392 47.9432 20.3333 47.9727 20.3451C48.2028 20.4926 48.4506 20.6872 48.6865 20.9232ZM48.2264 17.8791C48.4624 18.1151 48.657 18.357 48.8045 18.5811C48.8222 18.6047 48.8104 18.646 48.7868 18.6696C48.7632 18.6932 48.7219 18.705 48.6983 18.6873C48.4741 18.5398 48.2264 18.3452 47.9963 18.1092C47.7603 17.8732 47.5656 17.6313 47.4181 17.4072C47.4004 17.3836 47.4122 17.3423 47.4358 17.3187C47.4653 17.2892 47.5007 17.2833 47.5243 17.301C47.7485 17.4484 47.9963 17.6431 48.2264 17.8791ZM41.8609 37.536C42.1087 37.7838 42.3033 38.0434 42.439 38.2912C42.4567 38.3207 42.439 38.3679 42.4036 38.4033C42.3682 38.4387 42.321 38.4564 42.2915 38.4387C42.0379 38.303 41.7783 38.1024 41.5364 37.8605C41.2886 37.6127 41.0939 37.3532 40.9583 37.1054C40.9406 37.0759 40.9583 37.0287 40.9996 36.9933C41.035 36.9579 41.0822 36.9402 41.1116 36.9579C41.3653 37.0936 41.6249 37.2942 41.8668 37.536H41.8609ZM47.1881 14.9825C47.424 15.2185 47.6187 15.4544 47.7662 15.6786C47.7839 15.7022 47.778 15.7376 47.7485 15.7671C47.7249 15.7907 47.6895 15.7966 47.66 15.7848C47.4358 15.6373 47.1999 15.4426 46.9639 15.2067C46.7279 14.9707 46.5332 14.7347 46.3857 14.5105C46.368 14.4869 46.3739 14.4515 46.4034 14.422C46.427 14.3984 46.4624 14.3925 46.4919 14.4043C46.7161 14.5518 46.9521 14.7465 47.1881 14.9825ZM18.9828 43.1995C19.2188 43.4355 19.4548 43.6302 19.679 43.7776C19.7026 43.7953 19.738 43.7894 19.7675 43.76C19.7911 43.7364 19.797 43.701 19.7852 43.6715C19.6377 43.4473 19.443 43.2113 19.207 42.9753C18.971 42.7394 18.7351 42.5447 18.5109 42.3972C18.4873 42.3795 18.4519 42.3854 18.4224 42.4149C18.3988 42.4385 18.3929 42.4739 18.4047 42.5034C18.5522 42.7276 18.7469 42.9635 18.9828 43.1995Z",
    fill: "#661A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3386_4124",
    x: 0.5,
    y: 0.5,
    width: 58.4633,
    height: 58.4688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858333 0 0 0 0 0.515 0 0 0 0 0 0 0 0 0.82 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3386_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3386_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3386_4124",
    x1: 21.1656,
    y1: 46.2678,
    x2: 50.2204,
    y2: 17.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B04D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D35800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#AD4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D95900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B35610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3386_4124",
    x1: 40.8343,
    y1: 36.8397,
    x2: 16.8944,
    y2: 12.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E67900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC12A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3386_4124",
    x1: 52.5154,
    y1: 38.616,
    x2: 18.2219,
    y2: 4.31663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3386_4124",
    x1: 39.6309,
    y1: 35.6364,
    x2: 18.0979,
    y2: 14.1034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED6C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC12A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3386_4124",
    x1: 10.5585,
    y1: 32.7869,
    x2: 36.7874,
    y2: 6.56391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3386_4124",
    x1: 43.725,
    y1: 30.227,
    x2: 23.8793,
    y2: 10.3813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3386_4124",
    x1: 36.9881,
    y1: 40.6455,
    x2: 48.4566,
    y2: 29.1769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3386_4124",
    x1: 19.5787,
    y1: 44.7457,
    x2: 24.2215,
    y2: 40.1028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#661A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3386_4124",
    x1: 44.9522,
    y1: 17.7794,
    x2: 47.9432,
    y2: 14.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3386_4124",
    x1: 41.1412,
    y1: 37.1468,
    x2: 47.3121,
    y2: 30.9701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinDecorator);
export default __webpack_public_path__ + "static/media/coinDecorator.7f976c53da246b3d0350129a5e2c3c6e.svg";
export { ForwardRef as ReactComponent };